import * as R from 'ramda'

export const int2Hex = R.ifElse(R.either(R.isNil, R.isEmpty), R.identity, (num) => num.toString(16).toUpperCase())
export const hex2Int = R.ifElse(R.either(R.isNil, R.isEmpty), R.identity, (hex) => parseInt(hex, 16))
export const hexPrefix = (hex) => `0x${hex}`
export const int2HexWithPrefix = R.compose(hexPrefix, int2Hex, (num) => parseInt(num))
export const hexPad = (padLength) => (hex) => hex.padStart(padLength, 0)
export const int2HexWithPadAndPrefix = (pad) => R.compose(hexPrefix, hexPad(pad), int2Hex, (num) => parseInt(num))

export const round = (number, precision = 0) => Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)
export const floor = (number, precision = 0) => Math.floor(number * Math.pow(10, precision)) / Math.pow(10, precision)

const SECOND = 1000
const MINUTE = SECOND * 60
const HOUR = MINUTE * 60
const DAY = HOUR * 24
const MONTH = DAY * 30
const YEAR = MONTH * 12

const approxDuration = (r, approx, v) => {
  return `${r && approx ? '~' : ''}${v}` + (approx ? '' : ` ${Math.round(r)}ms`)
}

export const humanizeDurationMs = (ms, approx = true) => {
  if (ms === null) return 'na'

  let r

  const years = Math.floor(ms / YEAR)
  r = ms % YEAR

  const months = Math.floor(r / MONTH)
  r = ms % MONTH

  const days = Math.floor(r / DAY)
  r = ms % DAY

  const hours = Math.floor(r / HOUR)
  r = ms % HOUR

  const minutes = Math.floor(r / MINUTE)
  r = r % MINUTE

  const seconds = approx ? round(r / SECOND) : Math.floor(r / SECOND)
  r = r % SECOND

  if (years > 0) return approxDuration(r, approx, `${years}y ${months}m ${days}d ${hours}h ${minutes}m ${seconds}s`)
  if (months > 0) return `${months}m ${days}d ${hours}h ${minutes}m ${seconds}s`
  if (days > 0) return `${days}d ${hours}h ${minutes}m ${seconds}s`
  if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`
  if (minutes > 0) return `${minutes}m ${seconds}s`
  if (seconds > 0) return `${seconds}s`
  return `${ms}ms`
}

export const standardDeviation = (list, precision, mean) => {
  const n = list.length
  if (!list.length) return null
  if (mean === undefined) mean = list.reduce((a, b) => a + b) / n
  return round(Math.sqrt(list.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n), precision)
}

export const countDecimals = (value) => {
  if (value % 1 != 0) return value.toString().split('.')[1].length
  return 0
}
